import { axiosGet, axiosPost } from "../../../react_axios/Axios";
import { GET_ITENARY_USER, GET_ITINERARY_NOTE_DETAILS, getItenaryUserUrl, getItineraryNoteDetailsUrl, headers, INSERT_UPDATE_ITINERARY_NOTE, insertUpdateItineraryNoteUrl, } from "../../../utils/constants";


export const getItenaryUser_action = (DelegateRegistrationID) => async (dispatch) => {
    console.log(JSON.parse(sessionStorage.getItem('loginDataSS')), '.........................................')
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            DelegateRegistrationID: DelegateRegistrationID,
        }

        const res = await axiosGet(getItenaryUserUrl, params, headers)

        dispatch({
            type: GET_ITENARY_USER,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const insertUpdateItineraryNote_action = (ItineraryNoteID, DelegateSeminarDetailsID, B2BMeetingID, DelegateItineraryID, Note, ExhibitorItineraryID, ExhibitorSeminarDetailsID, VisitorItineraryID, ExhvisitorSeminarDetailsID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ItineraryNoteID: ItineraryNoteID,
            DelegateSeminarDetailsID: DelegateSeminarDetailsID,
            B2BMeetingID: B2BMeetingID,
            DelegateItineraryID: DelegateItineraryID,
            Note: Note,
            ExhibitorItineraryID: ExhibitorItineraryID,
            ExhibitorSeminarDetailsID: ExhibitorSeminarDetailsID,
            VisitorItineraryID: VisitorItineraryID,
            ExhvisitorSeminarDetailsID: ExhvisitorSeminarDetailsID,
        }

        const res = await axiosPost(insertUpdateItineraryNoteUrl, params, headers)

        dispatch({
            type: INSERT_UPDATE_ITINERARY_NOTE,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}

export const getItineraryNoteDetails_action = (ItineraryNoteID) => async (dispatch) => {
    try {
        const params = {
            UserID: JSON.parse(sessionStorage.getItem('loginDataSS')).UserID,
            ExhibitionID: sessionStorage.getItem('sessionExhibitionID'),
            ItineraryNoteID: ItineraryNoteID
        }

        const res = await axiosGet(getItineraryNoteDetailsUrl, params, headers)

        dispatch({
            type: GET_ITINERARY_NOTE_DETAILS,
            payload: res,
        });
        return Promise.resolve(res)
    } catch (error) {
        return Promise.reject(error)
    }
}